<script lang="ts" setup>
import CButton from '@lib/components/CButton/CButton.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import useReorderComponent from '@canvas-builder/composables/useReorderComponent'
import useThemeVars from '@lib/composables/useThemeVars'

const themeVars = useThemeVars()
const { activeTitle, activeComponent, selectParentComponent } = useReorderComponent()
</script>

<template>
  <div class="reorder-title font-size-4 text-center font-600 line-height-5 flex justify-center">
    <div class="flex-shrink-0 flex-grow-0">
      <CButton
        v-if="activeComponent"
        class="px-2"
        quaternary
        :style="{
          '--n-color': 'transparent',
          '--n-color-focus': themeVars.primary5,
          '--n-color-hover': themeVars.primary5,
        }"
        @click="selectParentComponent(activeComponent)"
      >
        <CIcon color="primary" icon="angle-left" :size="16" />
      </CButton>
    </div>

    <div v-tooltip="activeTitle" class="justify-center text-center pa-2 flex-grow-1 flex-shrink-1 truncate">
      {{ activeTitle }}
    </div>

    <div v-if="activeComponent" class="flex-shrink-1 w-8"></div>
  </div>
</template>

<style lang="scss" scoped>
.reorder-title {
  line-height: 20px;
  letter-spacing: 0.4px;
}
</style>
